module.exports = __webpack_public_path__ + "assets/14785e013e32ae05c3810e84df9b4575.mp3";